module.exports = __webpack_public_path__ + "static/media/reddit_full.8eef14068010a6aff737de5e15e108f3.svg";